import { useMemo } from "react";
import { AppId, FCX, ProductLogo } from "@datassential/platform-ui-lib";
import PeopleChart from "./PeopleChart";
import './PeopleSaying.scss';
import Widget from "@components/Widget/Widget";
import { useHomeAllWhatsHotData } from "@apiHooks/useHomeAllWhatsHotData";

const PeopleSaying: FCX = ({ className }) => {
    const { data, isLoading } = useHomeAllWhatsHotData();

    const chartData = useMemo(() => {
        const items = data?.data ?? [];

        const sortedItems = [...items]
            .sort((a, b) => (b.twelveMonthEngagementGrowth ?? 0) - (a.twelveMonthEngagementGrowth ?? 0))
            .slice(0, 10);

        return sortedItems.map(item => ({
            id: item.id ?? 0,
            name: item.name ?? '',
            value: Math.round(item.twelveMonthEngagementGrowth ?? 0),
        }));
    }, [data]);

    return (
        <Widget className="PeopleSaying" testId="blockPeopleSaying">
            <div className={`PeopleSaying__content ${className || ''}`}>
                {isLoading && (
                    <div className="TrendingNow__spinner">
                        <ProductLogo appId={AppId.Snap} type="regular"/>
                    </div>
                )}
                {!isLoading && chartData.length === 0 && <div className="PeopleSaying__no-data">No data available</div>}
                {!isLoading && chartData.length > 0 && <PeopleChart data={chartData}/>}
            </div>
        </Widget>
    );
};

export default PeopleSaying;
